(() => {
  angular
    .module('complianceFrameworkApp.core')
    .factory('formErrorsService', formErrorsService);

  function formErrorsService() {
    let setFormErrors = (form, response) => {
      angular.forEach(response.data, (errors, key) => {
        form[key].$dirty = true;

        angular.forEach(errors, e => {
          form[key].$setValidity(e, false);
        });
      });
    };

    let clearFormErrors = form => {
      angular.forEach(form, (value, key) => {
        if (value && value.hasOwnProperty('$modelValue')) {
          form[key].$valid = true;
          form[key].$dirty = false;
          form[key].$error = {};
        }
      });
    };

    let hasError = (form, name) => form[name].$invalid && form[name].$dirty;

    let errorMessage = (form, name, displayName) => {
      const result = [];
      angular.forEach(form[name].$error, (key, value) => {
        result.push(value);
      });
      
      return `${displayName || name} ${result.join(', ')}`;
    };

    return {
      setFormErrors: setFormErrors,
      clearFormErrors: clearFormErrors,
      hasError: hasError,
      errorMessage: errorMessage
    };
  }
})();
